import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {userApi, UsersFilterQuery} from "../api/userApi"
import {WSUser} from "../types/WebSocketTypes"
import {UserResponse, UsersResponse} from "../models/response"

export type UsersFilter = {
    limit: number
    offset: number
    status?: "-1" | "0" | "1"
}

type InitialStateType = {
    users: null | UsersResponse
    user: null | UserResponse
    filter: UsersFilter & UsersFilterQuery
    ws: WSUser | null
}

const initialState: InitialStateType = {
    users: null,
    user: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const userReducer= createSlice({
    name: 'userReducer',
    initialState,
    reducers: {
        setUsers(state, {payload}) {
            state.users = payload
        },
        setUser(state, {payload}) {
            state.user = payload
        },
        addUser(state, {payload}) {
            if (state.users) {
                state.users = {
                    total: state.users.total += 1,
                    data: [payload, ...state.users.data],
                }
            }
        },
        editUser(state, {payload}: PayloadAction<UserResponse>) {
            let index = state.users?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.users) state.users.data[index] = payload
            if (state.user) state.user = payload
        },
        setUsersFilter(state, {payload}) {
            state.filter = payload
        },
        setWSUser(state, {payload}: PayloadAction<WSUser | null>) {
            state.ws = payload
        },
    },
})

export const {setUsers, setUser, addUser, editUser, setUsersFilter, setWSUser} = userReducer.actions

export default userReducer.reducer

export const getUsers = asyncCreator
('userReducer/getUsers', userApi.getUsers, setUsers)

export const getUser = asyncCreator
('userReducer/getUser', userApi.getUser, setUser)

export const createUser = asyncCreator
('userReducer/createUser', userApi.createUser, addUser)

export const changeUser = asyncCreator
('userReducer/changeUser', userApi.changeUser, editUser)

export const deleteUser = asyncCreator
('userReducer/deleteUser', userApi.deleteUser)

export const changeUserSettings = asyncCreator
('userReducer/changeUserSettings', userApi.changeUserSettings, editUser)